React = require 'react'
t = require('views/internal/recup-with-helpers')('paid_product_info')
track = require 'debug/track'

module.exports = class extends React.Component
  displayName: 'PaidProductBannerComponent'

  render: t.renderable ->
    trackBCLink = ->
      track "Billing Page", "See All Benefits Link Click"
    { stringsKey, subtitleCount, infoUrl, epilogueCount, icon } = @props
    t.div '.billing-intro.u-clearfix', ->

      t.div '.billing-intro-header', style: marginBottom: '25px', ->

        t.h1 '.billing-intro-header-title', ->
          t.format [stringsKey, 'title']
        for n in [0...subtitleCount]
          t.p '.billing-intro-header-text', ->
            t.format [stringsKey, 'subtitles', n]
        return

      t.ul '.billing-intro-list', ->
        for n in [0...3]
          t.li '.billing-intro-list-item', ->
            t.h3 ->
              t.format [stringsKey, 'featureHeaders', n]
            t.p ->
              t.format [stringsKey, 'featureBodies', n]
        return

      if epilogueCount
        t.div '.billing-intro-header', ->
          for n in [0...epilogueCount]
            t.p ->
              t.format [stringsKey, 'epilogue recent', n]
          return

      t.div '.billing-intro-more', ->
        t.a '.billing-intro-more-link.quiet-button',
          href: infoUrl
          target: '_blank'
          onClick: trackBCLink
        , ->
          t.format [stringsKey, 'link']



// WEBPACK FOOTER //
// ./app/scripts/views/ads/paid-product-banner-component.coffee